import { render } from "./TheParticles.vue?vue&type=template&id=86660bf2"
import script from "./TheParticles.vue?vue&type=script&lang=js"
export * from "./TheParticles.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projekty\\Elektromeck\\electro-meck-project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__